import { render, staticRenderFns } from "./EmergingArtistCollection.vue?vue&type=template&id=8b738066&"
import script from "./EmergingArtistCollection.vue?vue&type=script&lang=js&"
export * from "./EmergingArtistCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports